/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M5.446 234.827c-6.321-5.352-6.273-13.979.101-19.262L200.99 53.571c6.377-5.286 11.547-2.852 11.547 5.431v104.406s297.952 6.046 297.952 304.073c0 0-34.899-177.581-299.975-177.581l.884 104.406c.07 8.285-4.995 10.665-11.318 5.311L5.446 234.827z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLeftCurvedArrow = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLeftCurvedArrow.defaultProps = {
  theme,
};
IconLeftCurvedArrow.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLeftCurvedArrow.displayName = 'IconLeftCurvedArrow';
export { IconLeftCurvedArrow };
